import { render, staticRenderFns } from "./PravnaOsoba.vue?vue&type=template&id=0e145137"
import script from "./PravnaOsoba.vue?vue&type=script&lang=js"
export * from "./PravnaOsoba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports